<template>
  <v-card>
    <v-card-title class="font-weight-medium secondary--text primary">
      <v-icon small color="secondary" class="mr-2">mdi-percent-outline</v-icon>
      GST Configuration
      <v-spacer />
      <v-btn small icon @click="$emit('closeDialog')">
        <v-icon small color="secondary">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />

    <v-card-text class="pt-5">
      <v-form ref="form" lazy-validation>
        <v-row dense>
          <v-col cols="12" md="12">
            <v-select
              v-model.number="form.particular"
              :items="paymentTypes"
              item-text="name"
              item-value="id"
              label="Particular *"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="form.cgst"
              label="CGST (%) *"
              outlined
              dense
              hide-details="auto"
              type="number"
              step="0.01"
              min="0"
              max="100"
              :rules="[rules.required, rules.percentage]"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="form.sgst"
              label="SGST (%) *"
              outlined
              dense
              hide-details="auto"
              type="number"
              step="0.01"
              min="0"
              max="100"
              :rules="[rules.required, rules.percentage]"
            />
          </v-col>

         <!-- <v-col cols="12" md="4">
            <v-text-field
              v-model.number="form.igst"
              label="IGST (%) *"
              outlined
              dense
              hide-details="auto"
              type="number"
              step="0.01"
              min="0"
              max="100"
              :rules="[rules.required, rules.percentage]"
            />
          </v-col>-->

        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions class="px-4 pb-4 pt-3">
      <v-spacer />
      <v-btn class="accent white--text" :loading="loading" @click="save">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    gstConfiguration: {
      type: Object,
      default: null,
    },
    paymentTypes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      rules: {
        ...rules,
        percentage: (v) => (v !== null && v !== "" && v >= 0 && v <= 100) || "Must be 0–100",
      },
      form: { particular: null, cgst: null, sgst: null, igst: 0 },
      loading: false,
    };
  },
  created() {
    this.form.particular = "Add-on Programme";
  },
  computed: {
    intraStateTotal() {
      const c = parseFloat(this.form.cgst) || 0;
      const s = parseFloat(this.form.sgst) || 0;
      return (c + s).toFixed(2).replace(/\.00$/, "");
    },
  },

  watch: {
    gstConfiguration: {
      handler(val) {
        if (val) {
          this.form = {
            cgst: parseFloat(val.cgst),
            sgst: parseFloat(val.sgst),
            igst: parseFloat(val.igst),
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const res = await this.$axios.post("/gst_configuration", {
          gst_configuration: this.form,
        });
        this.$store.commit("showSnackbar", {
          message: "GST configuration saved successfully",
          color: "success",
        });
        this.$emit("saved", res.data.data);
      } catch (e) {
        this.$store.commit("showSnackbar", {
          message: e.response?.data?.error || "Failed to save GST configuration",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
